import PopoverBase from '../PopoverBase'
import './styles.scss'

export default class Dropdown extends PopoverBase {
  static defaultProps = {
    ...PopoverBase.defaultProps,
    align: 'start',
    animation: 'none',
    edgeOffset: 3,
    hasCaret: false,
    interactive: true,
    position: 'bottom',
    popoverHandlers: { duration: [0, 0] },
    sticky: 'reference',
    type: 'dropdown',
  }
}
Dropdown.displayName = 'Kuiper: Dropdown ← PopoverV2'
